import RpcService   from '@/core/services/Rpc/RpcService';
import RpcResponse   from '@/core/services/Rpc/RpcResponse';

import type CharacteristicGroup from '@/domains/CharacteristicGroups/CharacteristicGroup';
import type RpcDataPagination   from '@/core/services/Rpc/RpcDataPagination';
import type RpcDataSort         from '@/core/services/Rpc/RpcDataSort';

class CharacteristicGroupsDAO {

	static async getList(
		filters?: {
      pattern?:   string,
      name?:      string,
      isDeleted?: boolean,
    },
		pagination?: RpcDataPagination,
		sort?: RpcDataSort,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest(
			'characteristicGroups.getList',
      {
        ...filters,
      },
			pagination,
			sort,
			true, null, null, false,
			{ abortPrevious: true },
		);
	}

	static async add(characteristicGroup: CharacteristicGroup): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristicGroups.add', { characteristicGroup });
	}

	static async update(characteristicGroup: CharacteristicGroup): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristicGroups.update', { characteristicGroup });
	}

	static async delete(id: number): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristicGroups.delete', { id });
	}

	static async changeSort(
		movedElementId: number,
		targetElementId: number,
		insertAfter: boolean,
	): Promise<RpcResponse> {
		return await RpcService.makeRequest('characteristicGroups.changeSort', {
			movedElementId,
			targetElementId,
			insertAfter,
		});
	}
}

export default CharacteristicGroupsDAO;
